import { create } from "zustand";

/**
 * Which sidebar pane is showing.
 *
 * This used to be `useState` inside `Sidebar`, which was fine while nothing
 * outside needed to change it. The Climate pane broke that: flooding is a
 * hazard, it lives in the Risks pane, and duplicating it into Climate would
 * mean two places to keep in step. A cross-link needs to be able to switch the
 * pane from outside the Sidebar's own tree.
 *
 * Not persisted, deliberately. Which pane you left open is a fact about one
 * sitting, not a preference, and restoring it would drop a returning user
 * somewhere other than the map.
 */
export type TabId =
  | "explore"
  | "scenario"
  | "people"
  | "risks"
  | "climate"
  | "stats"
  | "cost";

interface UiState {
  tab: TabId;
  setTab: (tab: TabId) => void;
}

export const useUiStore = create<UiState>((set) => ({
  tab: "explore",
  setTab: (tab) => set({ tab }),
}));
